import TextSliced from './TextSliced'

export default TextSliced
